
<template>
    <div id="gooogleMap" class="map-wrap" ref="googleMap" style="height: 100%;"></div>
</template>

<script>

import MapsHelpers from '@/mixins/MapsHelpers'

export default {

    mixins: [MapsHelpers],

    data() {
        return {
            google: null,
            map: null,
            bounds: null,
            spots: [],
            markers: [],
            firstLoaded: true,
        }
    },

    created() {

        eventBus.$on('google-api-is-ready', google => {
            this.google = google
            this.$nextTick(this.initializeMap)
        })

        eventBus.$on('gotSpots', this.drawMarkers);
        eventBus.$on('markerBigger', this.makeMarkerBig);
        eventBus.$on('markerSmall', this.makeMarkersSmall);
    },

    methods: {

        initializeMap() {

            let options = {
                zoom: 9,
                center: {lat: -34.397, lng: 150.644},
                styles: this.mapStyles,
                mapTypeControl: false,
                fullscreenControl: false,
                streetViewControl: false
            }

            const mapContainer = this.$refs.googleMap;

            this.map = new google.maps.Map(mapContainer, options)

            if (!config.user) {
                $('.map-main').css({'bottom': '0px'})
            }
        },

        // We receive the spots in the data because one day might want to submit the paginator object instead
        drawMarkers(data) {

            this.spots = data.spots;

            this.bounds = new google.maps.LatLngBounds()
            var infoWindow = new google.maps.InfoWindow();

            this.markers.forEach(marker => marker.setMap(null))
            this.markers = [];

            this.spots.forEach(spot => {

                // Skip this callback if not lat and lng on the spot
                if (spot.latitude == null || spot.longitude == null) {
                    return
                };

                var location = {
                    lat: spot.latitude,
                    lng: spot.longitude,
                };

                var icon = {
                    url: this.icons[spot.category.slug].icon,
                    scaledSize: new google.maps.Size(25, 29),
                };

                let zIndex = spot.category.slug == 'eat' ? 300 : 200;

                let routeUrl = `/${spot.city.slug}/${spot.slug}`;

                var marker = new google.maps.Marker({
                    id: spot.id,
                    position: location,
                    map: this.map,
                    zIndex: zIndex,
                    info: `<a href="${routeUrl}">
                                    <div class="map-info-window">${spot.title}<br />
                                        <span>${spot.category.title}</span>
                                        <small>Details</small>
                                        <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg>
                                    </div>
                                </a>`,
                    icon: icon,
                    link: routeUrl
                });

                this.markers.push(marker);

                this.google.maps.event.addListener(marker, 'click', function () {
                    eventBus.$emit('move-scroll-to-spot', this.id);
                    infoWindow.setContent(this.info);
                    infoWindow.open(this.map, this);
                });

                this.google.maps.event.addListener(marker, 'mouseover', function () {
                    infoWindow.setContent(this.info);
                    infoWindow.open(this.map, this);
                });

                this.bounds.extend(marker.position);
            });

            if(this.firstLoaded || (data.hasOwnProperty('autofocus') && data.autofocus == true)) {
                this.focusMap()
                $("html, body").animate({scrollTop: 0})
                this.$nextTick(() => {
                    $('.map-main .loader').hide();
                })
            }

            this.firstLoaded = false
        },

        focusMap() {
            this.map.fitBounds(this.bounds);
            // this.map.setCenter(this.bounds.getCenter());

            //     if (lat_override == '' && lng_override == '') {
            //         if (this.firstLoad)
            //             this.initialBounds = bounds;
            //
            //         this.firstLoad = false;
            //     }
            //
        },



        makeMarkerBig(spot) {
            this.makeMarkersSmall(spot);
            this.markers.forEach(marker => {
                if (marker.id == spot.id) {
                    var icon = {
                        url: this.icons[spot.category.slug].icon,
                        scaledSize: new google.maps.Size(30, 35),
                    };
                    marker.setIcon(icon);
                    marker.setZIndex(500);
                    this.google.maps.event.trigger(marker, 'mouseover');
                }
            });
        },

        makeMarkersSmall(spot) {
            this.markers.forEach(marker => {
                if (marker.id == spot.id) {
                    // let marker = _.find(this.markers, m => m.id == spot.id);
                    marker.setIcon({
                        url: this.icons[spot.category.slug].icon,
                        scaledSize: new google.maps.Size(25, 29),
                    });
                    marker.setZIndex((spot.category.slug == 'eat' ? 300 : 200));
                }
            });
        }

        // setBackVariables() {
        //     localStorage.setItem("mapCenter", JSON.stringify(this.map.getCenter()));
        //     localStorage.setItem("mapZoom", this.map.getZoom());
        // },
        //
        // setAllMarkersSmall() {
        //     this.recommendations.forEach((recommendation, index) => {
        //         this.markers.forEach((marker, index) => {
        //
        //             if(recommendation.id == marker.id) {
        //                 var icon = {
        //                     url: this.icons[recommendation.category.slug].icon,
        //                     scaledSize: new google.maps.Size(25, 29),
        //                 };
        //                 marker.setIcon(icon);
        //                 marker.setZIndex(200);
        //                 if (recommendation.category.slug == 'eat')
        //                     marker.setZIndex(300);
        //             }
        //         });
        //
        //     });
        // }
    },
}
</script>
N3w$3tt3?
